import { Transaction } from './transaction'
import { Commons } from '../../utils/commons'

class Formatter {
  static parseExternalTransaction(rawTransaction) {
    if (!rawTransaction) return null
    const transaction = new Transaction()
    let status = rawTransaction.status
    let statusDetailed =
      rawTransaction.dstDetailedStatus ||
      rawTransaction.srcDetailedStatus ||
      status
    if (
      rawTransaction.srcStatus == 'success' &&
      rawTransaction.dstStatus !== 'success'
    ) {
      statusDetailed = 'paidWaiting'
    }

    transaction
      .setReference(rawTransaction.id)
      .setStatus(rawTransaction.status)
      .setStatusCode(statusDetailed)
      .setStartTimestamp(rawTransaction.date)
      .setEndTimestamp(rawTransaction.endDate)
      .setPaymentUrl(rawTransaction.paymentUrl)
      .setOperationName(getOperationName(rawTransaction, true))
      .setOperationType(getOperationType(rawTransaction))
      .setOperationNameDisplay(getOperationName(rawTransaction))
      .setLogo(rawTransaction.operationLogoUrl)
      .setStartDate(
        Commons.timestampToDate(rawTransaction.date, 'DD MMM YYYY - HH:mm'),
      )
      .setEndDate('0')
      .setPaymentReason('')
      .setAmountToSend(rawTransaction.amounts?.srcAmount)
      .setCurrencyToSend(rawTransaction.amounts?.srcCurrency)
      .setAmountToReceive(rawTransaction.amounts?.dstAmount)
      .setCurrencyToReceive(rawTransaction.amounts?.dstCurrency)
      .setFee(rawTransaction.amounts?.totalFee)
      .setFeeCurrency(rawTransaction.amounts?.feeCurrency)
      .setSenderFirstName()
      .setSenderLastName()
      .setRecipientFirstName('')
      .setRecipientLastName('')
      .setSenderAccount('')
      .setRecipientAccount('')
      .setMetaData(rawTransaction)
    return transaction
  }

  static buildTransactionEntity(rawTransaction) {
    if (!rawTransaction) return null
    const transaction = new Transaction()
    transaction
      .setReference(rawTransaction.reference)
      .setStatus(rawTransaction.status)
      .setStatusCode(rawTransaction.statusCode)
      .setStartTimestamp(rawTransaction.startTimestamp)
      .setEndTimestamp(rawTransaction.endTimestamp)
      .setPaymentUrl(rawTransaction.paymentUrl)
      .setOperationName(rawTransaction.operationName)
      .setOperationType(rawTransaction.operationType)
      .setOperationNameDisplay(rawTransaction.operationNameDisplay)
      .setOperationTypeDisplay(rawTransaction.operationTypeDisplay)
      .setStatusToDisplay(rawTransaction.statusToDisplay)
      .setLogo(rawTransaction.logo)
      .setStartDate(rawTransaction.startDate)
      .setEndDate(rawTransaction.endDate)
      .setPaymentReason(rawTransaction.paymentReason)
      .setStatusMessage(rawTransaction.statusMessage)
      .setAmountToSend(rawTransaction.amountToSend)
      .setCurrencyToSend(rawTransaction.currencyToSend)
      .setAmountToReceive(rawTransaction.amountToReceive)
      .setCurrencyToReceive(rawTransaction.currencyToReceive)
      .setFee(rawTransaction.fee)
      .setFeeCurrency(rawTransaction.feeCurrency)
      .setSenderFirstName(rawTransaction.senderFirstName)
      .setSenderLastName(rawTransaction.senderLastName)
      .setRecipientFirstName(rawTransaction.recipientFirstName)
      .setRecipientLastName(rawTransaction.recipientLastName)
      .setSenderAccount(rawTransaction.senderAccount)
      .setRecipientAccount(rawTransaction.recipientAccount)
      .setMetaData(rawTransaction.metaData)
    return transaction
  }
}

const types = {
  fund1xBet: { name: 'Dépot 1xBet', i18nId: 'fund_1xbet', type: '1xbet' },
  fundBetWinner: {
    name: 'Dépot Betwinner',
    i18nId: 'fund_betwinner',
    type: 'betwinner',
  },
  fund1Win: { name: 'Dépot 1Win', i18nId: 'fund_1win', type: '1Win' },
  // fundBookmaker: { name: 'Dépot Bookmaker', i18nId: '', type: '' },
  withdrawal1xBet: {
    name: 'Retrait 1xBet',
    i18nId: 'withdraw_1xbet',
    type: '1xbet',
  },
  withdrawalBetWinner: {
    name: 'Retrait Betwinner',
    i18nId: 'withdraw_betwinner',
    type: 'betwinner',
  },
  withdrawal1Win: {
    name: 'Retrait 1Win',
    i18nId: 'withdraw_1win',
    type: '1Win',
  },
  // withdrawBookmaker: { name: 'Retrait Bookmaker', i18nId: '', type: '' },
  buyUsdt: { name: 'Achat de USDT', i18nId: 'buy_usdt', type: 'usdt' },
  // buy: { name: 'Achat', i18nId: 'buy_usdt', type: '' },
  sellUsdt: { name: 'Vente de USDT', i18nId: 'sell_usdt', type: 'usdt' },
  sellGiftCard: {
    name: 'Vente de Giftcard',
    i18nId: 'sell_giftcard',
    type: 'giftcard',
  },
  // sell: { name: 'Vente', i18nId: '', type: '' },
  withdrawalWallet: {
    name: 'Retrait depuis wallet',
    i18nId: 'withdraw_wallet',
    type: 'kingrecharge',
  },
  fundWallet: {
    name: 'Recharge de wallet',
    i18nId: 'fund_wallet',
    type: 'kingrecharge',
  },
  unknown: {
    name: 'Operation Rapidoo',
    i18nId: 'unknown',
    type: 'kingrecharge',
  },
}

function getOperationName(rawTransaction, i18nId) {
  if (rawTransaction.operationType) {
    const operation = types[rawTransaction.operationType]
    if (i18nId) return operation?.i18nId || 'Opération Rapidoo'
    return operation?.name || 'Opération Rapidoo'
  }
  const srcOperation = rawTransaction.src.operationType
  const dstOperation = rawTransaction.dst.operationType
  if (dstOperation === 'bookmaker') {
    if (i18nId) return 'fund_' + rawTransaction.dst.bookmaker.toLowerCase()
    return 'Recharge de ' + rawTransaction.dst.bookmaker
  } else if (srcOperation === 'bookmaker') {
    if (i18nId) return 'withdraw_' + rawTransaction.src.bookmaker.toLowerCase()
    return 'Retrait de ' + rawTransaction.src.bookmaker
  } else if (
    dstOperation === 'manualOperation' &&
    /usdt/i.test(rawTransaction.dst.type)
  ) {
    if (i18nId) return 'buy_usdt'
    return 'Achat de usdt'
  } else if (
    srcOperation === 'manualOperation' &&
    /usdt/i.test(rawTransaction.src.type)
  ) {
    if (i18nId) return 'sell_usdt'
    return 'Vente de usdt '
  } else if (
    srcOperation === 'manualOperation' &&
    /giftcard/i.test(rawTransaction.src.type)
  ) {
    if (i18nId) return 'sell_giftcard'
    return 'Vente de Cartes Cadeaux'
  } else if (srcOperation === 'wallet') {
    if (i18nId) return 'withdraw_wallet'
    return 'Retrait de wallet'
  } else if (dstOperation === 'wallet') {
    if (i18nId) return 'fund_wallet'
    return 'Recharge de wallet'
  }
  // Ajoutez d'autres conditions ici selon vos besoins
  else {
    return 'opération Rapidoo'
  }
}

function getOperationType(rawTransaction) {
  if (rawTransaction.operationType) {
    const operation = types[rawTransaction.operationType]
    return operation?.type || 'kingrecharge'
  }
  const srcOperation = rawTransaction.src.operationType
  const dstOperation = rawTransaction.dst.operationType
  if (dstOperation === 'bookmaker' || srcOperation === 'bookmaker') {
    return rawTransaction.src.bookmaker || rawTransaction.dst.bookmaker
  } else if (
    (dstOperation === 'manualOperation' &&
      /usdt/i.test(rawTransaction.dst.type)) ||
    (srcOperation === 'manualOperation' &&
      /usdt/i.test(rawTransaction.src.type))
  ) {
    return 'usdt'
  } else if (
    srcOperation === 'manualOperation' &&
    /giftCard/i.test(rawTransaction.src.type)
  ) {
    return 'giftcard'
  } else {
    return 'kingrecharge'
  }
}

function formatMetaData(rawTransaction = {}) {
  const metaDataKeys = [
    'reference',
    'userName',
    'phoneNumber',
    'amountUserSent',
    'currencyUserSent',
    'amountUserReceived',
    'currencyUserReceived',
    'fee',
    'feeCurrency',
    'accountId',
    'withdrawalCode',
    'email',
    'operationType',
    'operationName',
    'operationTypeText',
    'cryptoAddress',
    'operator',
    'startTimestampInSecond',
    'cryptoName',
    'cryptoId',
    'cryptoSellingReference',
    'useBinance',
    'createdAt',
    'paymentEndDate',
    'countryCode',
    'countryName',
    'statusCode',
    'status',
    'statusText',
    'statusTextDetailed',
    'adminMessage',
    'serviceName',
    'operationTitle',
    'startDate',
    'operationDescription',
    'userAccountId',
    'adminId',
    'finished',
    'locked',
    'lastUpdate',
    'paymentUrl',
    'isManual',
    'manualPaymentReference',
    'operationLogoUrl',
    'userPictureUrl',
    'acceptingUrl',
    'rejectionUrl',
    'validationUrl',
    'transactionLaunched',
  ]
  const metaData = {}
  metaDataKeys.forEach(key => {
    metaData[key] = rawTransaction[key]
  })
  return metaData
}

export { Formatter }
